import axios from 'axios';

export default axios.create({
  // baseURL: `https://api-bimbingan.uajy.ac.id/`,
  baseURL: `https://api-bim.rigun-page.com/`,
});
